import React, { useState } from 'react';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { Tooltip } from '@material-ui/core';
import RichText from '../../../../../utils/RichText';
import { getDefaultIcon } from '../../../../../utils/functions';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import closeButton from '../../../../../components/images/close-button.svg';
import CustomInputCheckbox from '../../../../../utils/redux-forms-custom-fields/CustomInputCheckbox';
import { getStepsOptions } from '../../constants/options';
import {
  AdminBannerIcon,
  AdminGameDirectoryIcon,
  AdminGameKeyIcon,
  AdminHashtagIcon,
  AdminCheckboxIcon,
  AdminAchievementIcon,
  AdminClipIcon,
  AdminTextIcon,
  AdminLinkIcon,
  AdminStreamIcon,
  AdminTwitterIcon,
  AdminVerificationIcon,
  AdminBuildStreamIcon
} from '../../../../images/requirement-icons/requirementIcons';
import './Requirements.css';
import MultiVideoSubmissionFields from './MultiVideoSubmissionFields';

const BaseModal = ({
  isOpen,
  onClose,
  title,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <section className={`ModalMaster_requirements`}>
      <div onClick={onClose} className="Modal__layer" aria-hidden />
      <section className="Modal__wrapper">
        <img
          alt="close-button"
          className="close"
          src={closeButton}
          onClick={onClose}
        />
        {title && <h2>{title}</h2>}
        {children}
      </section>
    </section>
  );
};

// 抽取工具函数 - 获取要求项状态
const getRequirementState = (req, questForm) => {
  console.log('req', req);
  console.log('questForm', questForm);
  const states = {
    'display-download': {
      banner: {
        condition: !questForm?.values?.requiredBanner,
        message: 'You must upload banner artwork in the \'Details\' section for this requirement to become available.'
      },
      overlay: {
        condition: !questForm?.values?.overlayImage,
        message: 'You must upload overlay artwork in the \'Details\' section for this requirement to become available.'
      }
    },
    'display-hashtags': {
      tracking: {
        condition: !questForm?.values?.trackingTags?.length,
        message: 'You must add tracking hashtags in the \'Parameters\' section for this requirement to become available.'
      },
      quest: {
        condition: !questForm?.values?.questTags?.length,
        message: 'You must add quest hashtags in the \'Parameters\' section for this requirement to become available.'
      }
    },
    'multi-video-submission': {
      tracking: {
        condition: !questForm?.values?.trackingTags?.length,
        message: 'You must add tracking hashtags in the \'Parameters\' section for this requirement to become available.'
      },
    }
  };

  const typeState = states[req.type];
  console.log('typeState', typeState);
  if (!typeState) return { inactive: false, tooltip: '' };

  const subtypeState = typeState[req.subtype];
  console.log('subtypeState', subtypeState);

  if (!subtypeState) return { inactive: false, tooltip: '' };

  return {
    inactive: subtypeState.condition,
    tooltip: subtypeState.condition ? subtypeState.message : ''
  };
};

// 抽取可重用的要求项组件
const RequirementItem = ({ req, inactive, tooltip, onAdd }) => {
  const inactiveClass = classNames({ inactive });

  // 渲染图标的辅助函数
  const getRequirementIcon = (req) => {
    switch (req.value) {
      case 'display-download-banner':
      case 'display-download-overlay':
        return <AdminBannerIcon className={inactiveClass} />;
      case 'display-text-checkbox':
        return <AdminCheckboxIcon className={inactiveClass} />;
      case 'display-text-build-stream':
        return <AdminBuildStreamIcon className={inactiveClass} />;
      case 'display-text-game-name':
        return <AdminGameDirectoryIcon className={inactiveClass} />;
      case 'distribute-key':
        return <AdminGameKeyIcon className={inactiveClass} />;
      case 'display-hashtags-quest':
      case 'display-hashtags-tracking':
        return <AdminHashtagIcon className={inactiveClass} />;
      case 'submit-link-clip':
      case 'submit-link-vod':
      case 'submit-video-youtube':
      case 'multi-video-submission':
        return <AdminClipIcon className={inactiveClass} />;
      case 'display-text-achievement':
        return <AdminAchievementIcon className={inactiveClass} />;
      case 'submit-steam-achievement':
        return <AdminAchievementIcon className={inactiveClass} />;
      case 'submit-tweet':
        return <AdminTwitterIcon className={inactiveClass} />;
      case 'distribute-link-campaign':
      case 'distribute-link-affiliate':
        return <AdminLinkIcon className={inactiveClass} />;
      case 'display-stream-time':
        return <AdminStreamIcon className={inactiveClass} />;
      case 'display-text':
        return <AdminTextIcon className={inactiveClass} />;
      case 'submit-text':
      case 'submit-text-optional':
      default:
        return <AdminVerificationIcon className={inactiveClass} />;
    }
  };

  const content = (
    <div
      className="reqSelect"
      onClick={!inactive ? () => onAdd(req) : null}
    >
      <div className="icon">
        {getRequirementIcon(req)}
      </div>
      <span className={inactiveClass}>{req.label}</span>
    </div>
  );

  return tooltip ? (
    <Tooltip key={req.value} title={tooltip} placement="top">
      {content}
    </Tooltip>
  ) : content;
};
// 优化后的 RequirementModal 组件
const RequirementModal = ({ isOpen, onClose, stepTypeOptions, onAdd, questForm }) => {
  if (!isOpen) return null;

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title="Add New Requirement"
    >
      <div className="reqContainer">
        {stepTypeOptions.map((req) => {
          const { inactive, tooltip } = getRequirementState(req, questForm);
          return (
            <RequirementItem
              key={req.value}
              req={req}
              inactive={inactive}
              tooltip={tooltip}
              onAdd={onAdd}
            />
          );
        })}
      </div>
    </BaseModal>
  );
};


const RequirementControls = ({ index, totalLength, pointInQuest, onSwapRequirement }) => {
  const showUpArrow = index !== 0;
  const showDownArrow = totalLength - 1 !== index;

  return (
    <section className="Step__arrows">
      {showUpArrow && (
        <div
          className="Step__arrow--up"
          onClick={() => onSwapRequirement(pointInQuest, index, 'up')}
          aria-hidden
        >
          <i className="fa fa-arrow-up" />
        </div>
      )}
      {showDownArrow && (
        <div
          className="Step__arrow--down"
          onClick={() => onSwapRequirement(pointInQuest, index, 'down')}
          aria-hidden
        >
          <i className="fa fa-arrow-down" />
        </div>
      )}
    </section>
  );
};

const Requirements = ({ fields, meta: { error, submitFailed }, pointInQuest, questForm, game, onImageUpload, onRichTextUpdate, onAddRequirement, onSwapRequirement, onOpenAchievementModal = () => {}, onRemoveAchievement = () => {} }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const fieldValues = fields.getAll();

  const stepTypeOptions = getStepsOptions(
    questForm.values?.type === 'affiliate',
    questForm.values?.requirePreapproval,
    questForm.values
  );


  const getStepReadOnly = (req) => {
    console.log('getStepReadOnly', req);
    if (['display-hashtags', 'display-stream-time','multi-video-submission'].includes(req.type)) {
      return true;
    } else if (req.type === 'display-text' && req.subtype === 'game-name') {
      return true;
    }
    return false;
  };

  


  const handleAddRequirement = (req) => {
    onAddRequirement(fields, req);
    setIsModalOpen(false);
  };
  return (
    <section className="Step">
      <ul>
        {fields.map((step, index) => (
          <li key={index}>
            <section className="Step__header">
              <button
                className="Step__item-remove"
                type="button"
                id={pointInQuest}
                onClick={() => fields.remove(index)}
              >
                Remove requirement
              </button>
              <h4 className="Step__title">Requirement #{index + 1}</h4>
            </section>
            <section className="Step__body">
              <section className="Step__fields">
                {/* Type Display */}
                <div className="Step__row">
                  <div className="input-container" style={{ width: '20%' }}>
                    <label>Requirement Type</label>
                    <span style={{ fontSize: '16px', marginTop: '8px' }}>
                      {stepTypeOptions.find(o =>
                        o.type === fieldValues[index].type &&
                        o.subtype === fieldValues[index].subtype
                      )?.label}
                    </span>
                  </div>

                  {/* Title Input */}
                  <div className="input-container" style={{ width: '75%' }}>
                    <Field
                      name={`${step}.title`}
                      id={`${step}.title`}
                      type="text"
                      component={CustomInput}
                      label="Title"
                      placeholder="Title"
                      readOnly={getStepReadOnly(fields.get(index))}
                      customLabel="Title"
                    />
                  </div>
                </div>

                {/* Icon & Description */}
                <div className="Step__row">
                  <div className="input-container" style={{ width: '25%' }}>
                    <label>Icon</label>
                    {['display-download'].includes(fieldValues[index].type) ? (
                      <img
                        alt="requirement-icon"
                        style={{ objectFit: 'cover', width: '80px', height: '80px' }}
                        src={getDefaultIcon(
                          fieldValues[index].type,
                          fieldValues[index].subtype,
                          questForm.values,
                          game
                        )}
                      />
                    ) : (
                      <div
                        className="QuestEdit__upload"
                        onClick={() => onImageUpload('icon', {
                          pointInQuestIcon: pointInQuest,
                          indexIcon: index
                        })}
                        style={{ cursor: 'pointer' }}
                        aria-hidden
                      >
                        <i className="fa fa-close" style={{
                          color: 'white',
                          position: 'absolute',
                          marginLeft: '70px'
                        }} aria-hidden />
                        <img
                          alt="requirement-icon"
                          style={{ objectFit: 'contain', width: '80px', height: '80px' }}
                          src={fieldValues[index].icon && fieldValues[index].customIcon
                            ? fieldValues[index].icon
                            : getDefaultIcon(
                              fieldValues[index].type,
                              fieldValues[index].subtype,
                              questForm.values,
                              game
                            )
                          }
                        />
                      </div>
                    )}
                  </div>

                  {/* Description Rich Text */}
                  <div className="input-container" style={{ width: '75%' }}>
                    <label>Description</label>
                    <RichText
                      callback={content => onRichTextUpdate(
                        content,
                        `requirements.${pointInQuest}[${index}].description`
                      )}
                      initialValue={fieldValues[index].description}
                    />
                  </div>
                </div>

                {/* Submit Fields */}
                {fieldValues[index].type === 'multi-video-submission' && (
                  <MultiVideoSubmissionFields step={step} />
                )}

                {/* Steam Achievement Fields */}
                {fieldValues[index].type === 'submit-steam-achievement' && (
                  <>
                    <div className="Step__row" style={{ width: '75%', marginLeft: '25%', marginTop: '10px' }}>
                      <div className="input-container" style={{ width: '100%' }}>
                        <Field
                          name={`${step}.achievementMustBeCompleted`}
                          id={`${step}.achievementMustBeCompleted`}
                          type="checkbox"
                          component={CustomInputCheckbox}
                          customLabel="Achievement must be completed during the quest period"
                        />
                        <div style={{ 
                          marginTop: '15px', 
                          fontSize: '12px', 
                          color: '#666',
                          lineHeight: '1.4',
                          padding: '8px 12px',
                          backgroundColor: 'rgba(0, 123, 255, 0.1)',
                          border: '1px solid rgba(0, 123, 255, 0.2)',
                          borderRadius: '4px'
                        }}>
                          If checked, users must complete the achievement during the quest time period. 
                          If unchecked, users who already have the achievement can also participate.
                        </div>
                      </div>
                    </div>
                    
                    {/* Selected Achievements List */}
                    <div className="Step__row" style={{ width: '75%', marginLeft: '25%', marginTop: '10px' }}>
                      <div className="input-container" style={{ width: '100%' }}>
                        <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 'bold' }}>
                          Selected Achievements
                        </label>
                        
                        {/* Display selected achievements */}
                        {fieldValues[index].gameAchievements && fieldValues[index].gameAchievements.length > 0 ? (
                          <div style={{ marginBottom: '16px' }}>
                            {fieldValues[index].gameAchievements.map((achievement, achIndex) => (
                              <div 
                                key={achievement.id} 
                                className="achievement-card"
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding: '12px',
                                  margin: '8px 0',
                                  backgroundColor: 'rgba(0, 0, 0, 0.8)',
                                  border: `1px solid ${achievement.hidden ? '#666' : '#444'}`,
                                  borderRadius: '8px',
                                  boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                                  color: '#fff'
                                }}
                              >
                                {/* 成就图片 */}
                                <div style={{
                                  width: '48px',
                                  height: '48px',
                                  marginRight: '12px',
                                  borderRadius: '4px',
                                  overflow: 'hidden',
                                  backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                  position: 'relative',
                                  border: '2px solid rgba(255, 255, 255, 0.2)',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}>
                                  <img 
                                    src={achievement.icon} 
                                    alt={achievement.displayName}
                                    style={{
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'contain',
                                      borderRadius: '2px',
                                      opacity: achievement.hidden ? 0.7 : 1
                                    }}
                                    onError={(e) => {
                                      console.error('成就图片加载失败:', achievement.icon, achievement);
                                      e.target.style.display = 'none';
                                      e.target.parentElement.innerHTML = '<div style="width:100%;height:100%;background:rgba(255,255,255,0.1);display:flex;align-items:center;justify-content:center;font-size:12px;color:#fff;">🏆</div>';
                                    }}
                                    onLoad={() => {
                                      console.log('成就图片加载成功:', achievement.icon);
                                    }}
                                  />
                                  {/* 隐藏成就标识 */}
                                  {achievement.hidden && (
                                    <div style={{
                                      position: 'absolute',
                                      top: '-4px',
                                      right: '-4px',
                                      background: 'linear-gradient(45deg, #e53e3e, #c53030)',
                                      color: 'white',
                                      borderRadius: '50%',
                                      width: '18px',
                                      height: '18px',
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      fontSize: '9px',
                                      fontWeight: 'bold',
                                      border: '2px solid white',
                                      boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                                    }}>
                                      ?
                                    </div>
                                  )}
                                </div>
                                
                                {/* 成就信息 */}
                                <div style={{ flex: 1 }}>
                                  <div style={{
                                    fontWeight: 'bold',
                                    fontSize: '14px',
                                    color: '#fff',
                                    marginBottom: '4px'
                                  }}>
                                    {achievement.displayName}
                                  </div>
                                  <div style={{
                                    fontSize: '12px',
                                    color: '#ccc',
                                    marginBottom: '4px'
                                  }}>
                                    {achievement.description}
                                  </div>
                                  <div style={{
                                    fontSize: '11px',
                                    color: '#27ae60',
                                    fontWeight: 'bold'
                                  }}>
                                    全球完成率: {achievement.globalPercent > 0 ? `${achievement.globalPercent.toFixed(1)}%` : '< 0.1%'}
                                  </div>
                                </div>
                                
                                {/* 操作按钮 */}
                                <div style={{ display: 'flex', gap: '8px' }}>
                                  <button
                                    type="button"
                                    onClick={() => onOpenAchievementModal && onOpenAchievementModal(pointInQuest, index, true, achievement.id)}
                                    style={{
                                      background: '#3498db',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '4px',
                                      padding: '6px 12px',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    MODIFY
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() => onRemoveAchievement && onRemoveAchievement(achievement.id, pointInQuest, index)}
                                    style={{
                                      background: '#e74c3c',
                                      color: 'white',
                                      border: 'none',
                                      borderRadius: '4px',
                                      padding: '6px 12px',
                                      cursor: 'pointer',
                                      fontSize: '12px',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    REMOVE
                                  </button>
                                </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div style={{
                            padding: '20px',
                            textAlign: 'center',
                            backgroundColor: 'rgba(0, 0, 0, 0.6)',
                            border: '2px dashed #666',
                            borderRadius: '6px',
                            color: '#ccc',
                            marginBottom: '16px'
                          }}>
                            No achievements selected. Click "Add Achievement" to select Steam achievements for this requirement.
                          </div>
                        )}
                        
                        {/* Add Achievement Button */}
                        <button
                          type="button"
                          onClick={() => onOpenAchievementModal && onOpenAchievementModal(pointInQuest, index)}
                          style={{
                            background: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '12px 20px',
                            cursor: 'pointer',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            width: '100%',
                            height: '48px',
                            transition: 'background-color 0.2s ease'
                          }}
                          onMouseEnter={(e) => e.target.style.backgroundColor = '#0056b3'}
                          onMouseLeave={(e) => e.target.style.backgroundColor = '#007bff'}
                        >
                          + ADD ACHIEVEMENT
                        </button>
                      </div>
                    </div>
                  </>
                )}

                {fieldValues[index].type.includes('submit') && fieldValues[index].type !== 'submit-steam-achievement' && (
                  <div className="Step__row" style={{ width: '75%', marginLeft: '25%', marginTop: '10px' }}>
                    <div className="input-container" style={{ width: '45%' }}>
                      <Field
                        name={`${step}.label`}
                        id={`${step}.label`}
                        type="text"
                        component={CustomInput}
                        label="Label"
                        placeholder="Label"
                        customLabel="Label"
                      />
                    </div>
                    <div className="input-container" style={{ width: '45%' }}>
                      <Field
                        name={`${step}.placeholder`}
                        id={`${step}.placeholder`}
                        type="text"
                        component={CustomInput}
                        label="Placeholder"
                        placeholder="Placeholder"
                        customLabel="Placeholder"
                      />
                    </div>
                  </div>
                )}

                {/* Tooltip */}
                <div className="Step__row" style={{ width: '75%', marginLeft: '25%', marginTop: '10px', marginBottom: '10px' }}>
                  <div className="input-container">
                    <label>Tooltip</label>
                    <RichText
                      callback={content => onRichTextUpdate(
                        content,
                        `requirements.${pointInQuest}[${index}].tooltip`
                      )}
                      initialValue={fieldValues[index].tooltip}
                    />
                  </div>
                </div>

                {/* Show on App Options */}
                <div className="Step__row" style={{ width: '75%', marginLeft: '25%', marginTop: '10px' }}>
                  <div className="input-container" style={{ width: '45%' }}>
                    <Field
                      name={`${step}.showOnApp`}
                      id={`${step}.showOnApp`}
                      component={CustomInputCheckbox}
                      customLabel="Show on Application Page"
                    />
                  </div>
                  {questForm.values?.requirements[pointInQuest][index].showOnApp && (
                    <div className="input-container" style={{ width: '45%' }}>
                      <Field
                        name={`${step}.appPageTitle`}
                        id={`${step}.appPageTitle`}
                        component={CustomInput}
                        type="text"
                        label="Application Page Title"
                        customLabel="Application Page Title"
                        placeholder="Application Page Title"
                      />
                    </div>
                  )}
                </div>
              </section>

              {/* Up/Down Arrows */}
              <RequirementControls
                index={index}
                totalLength={fields.length}
                pointInQuest={pointInQuest}
                onSwapRequirement={onSwapRequirement}
              />
            </section>
          </li>
        ))}
      </ul>

      {/* Error Message */}
      {(submitFailed && error) && <span className="Step__error">{error}</span>}

      {/* Add Requirement Button */}
      <button
        className="Step__add-item"
        type="button"
        onClick={() => setIsModalOpen(true)}
      >
        Add Requirement
      </button>

      {/* Requirements Modal */}
      <RequirementModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onAdd={handleAddRequirement}
        stepTypeOptions={stepTypeOptions}
        questForm={questForm}
      />
    </section>
  );
};

export default Requirements;